import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {PieService, PieStatuses} from './pie.service';


@Component({
    selector: 'app-object-pie',
    templateUrl: './pie.component.html',
    styleUrls: ['./pie.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    providers: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ObjectPieComponent implements  OnInit {


  @Input() count = 30;
  @Input() size = 40;


  @Input() statuses: PieStatuses =
    {
      '-2': 20,
      '-1': 20,
      0: 4,
      1: 3,
      2: 4,
      3: 5
    }
  ;

  data;

  constructor(
    private translate: TranslateService,
    private pieService: PieService,
    private cdr: ChangeDetectorRef,
  ) {

  }


  ngOnInit(): void {
    this.data = this.pieService.create(this.statuses, this.size);
  }


}




